export const InvalidXMLRegex =
  // eslint-disable-next-line no-control-regex
  /((?:[\0-\u0008\u000B\f\u000E-\u001F\uFFFD-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/g;
